// extracted by mini-css-extract-plugin
module.exports = {"homeWrapper":"posts_homeWrapper__1CR6X"};